import { Component } from '@angular/core';
import { DiscussionPageBaseComponent } from '../../shared/discussion-page-base/discussion-page-base.component';

@Component({
  selector: 'app-discussion-announcement',
  standalone: true,
  imports: [DiscussionPageBaseComponent],
  template: `
    <app-discussion-page-base
      pageTitle="Announcement"
      pageDescription="Stay updated with the latest announcements, updates, and news from the MahaAgX platform and community."
      activeTab="announcement"
      categoryType="PRODUCT_ANNOUNCEMENTS"
    ></app-discussion-page-base>
  `,
})
export class DiscussionAnnouncementComponent {}
